// The 8 validation-rule categories (spec §6/§7).
// Each: id, label, accent (CSS var), icon (MUI component), description.
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import WcIcon from '@mui/icons-material/Wc';
import WorkIcon from '@mui/icons-material/Work';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import SchoolIcon from '@mui/icons-material/School';
import ApartmentIcon from '@mui/icons-material/Apartment';

export const categories = [
  {
    id: 'household',
    label: 'Household',
    accent: 'var(--cat-household)',
    icon: HomeWorkIcon,
    description: 'Household composition, roster and respondent validation rules.',
  },
  {
    id: 'women-child',
    label: 'Women & Child',
    accent: 'var(--cat-women-child)',
    icon: FamilyRestroomIcon,
    description: 'Anganwadi, nutrition and institutional delivery checks.',
  },
  {
    id: 'subhadra',
    label: 'Subhadra',
    accent: 'var(--cat-subhadra)',
    icon: VolunteerActivismIcon,
    description: 'Subhadra eligibility and beneficiary count validation.',
  },
  {
    id: 'gender',
    label: 'Gender',
    accent: 'var(--cat-gender)',
    icon: WcIcon,
    description: 'Gender vs relation consistency across the member roster.',
  },
  {
    id: 'skill-livelihood',
    label: 'Skill & Livelihood',
    accent: 'var(--cat-skill-livelihood)',
    icon: WorkIcon,
    description: 'Enumerator rate checks for skill, agriculture and livestock.',
  },
  {
    id: 'health',
    label: 'Health',
    accent: 'var(--cat-health)',
    icon: LocalHospitalIcon,
    description: 'Insurance coverage and health-related rate checks.',
  },
  {
    id: 'education',
    label: 'Education',
    accent: 'var(--cat-education)',
    icon: SchoolIcon,
    description: 'Age vs education level consistency checks.',
  },
  {
    id: 'housing',
    label: 'Housing',
    accent: 'var(--cat-housing)',
    icon: ApartmentIcon,
    description: 'Housing ownership rate checks by enumerator.',
  },
];

export const getCategoryById = (id) => categories.find((c) => c.id === id) || null;

export default categories;
